import { axios } from "@/plugins/axios.js";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createDeliveryNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/delivery_notes', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateDeliveryNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/api/v1/delivery_notes/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidDeliveryNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/delivery_notes/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDeliveryNote(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/delivery_notes/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchDeliveryNotes(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/delivery_notes', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}